import { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../../hoc/withRouter';
import Datatable from '../../../../components/common/datatable/index';
import { reenableScanning } from '../../../../actions/outlet';

class DisabledScansTable extends Component {
  render() {
    const { stores } = this.props;

    const actions = [
      {
        label: 'RE-ENABLE SCANNING',
        callback: (row) => {
          const { dispatch, isTeamRoute } = this.props;
          const path = isTeamRoute ? 'team' : 'admin';

          dispatch(reenableScanning(row.id, path));
        }
      }
    ];

    const columns = [
      {
        prop: 'customer-number',
        title: 'Customer number'
      },
      {
        prop: 'name',
        title: 'Outlet name'
      }
    ];

    return (
      <Datatable
        data={stores || []}
        columns={columns}
        actions={actions}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  stores: state.stores.stores,
  isTeamRoute: ownProps.location.pathname.includes('team'),
});

export default withRouter(connect(mapStateToProps)(DisabledScansTable));
